/* eslint-disable */
import {WOW} from 'wowjs/dist/wow';
import Isotope  from 'isotope-layout'
import SmoothScroll from 'smoothscroll-for-websites'


export default {
  init() {
    // JavaScript to be fired on all pages


    this.$win = $(window);
    this.$doc = $(document);
    this._hasIntro = true;
    this._skipload = false;

    this._states = {
      xs:window.matchMedia("(max-width : 768px)"),
      sm:window.matchMedia("(min-width : 768px)"),
      md:window.matchMedia("(min-width : 992px)"),
      lg:window.matchMedia("(min-width : 1200px)")
    }

    // this._onResize();

    $('body').on('click', "[data-action]", $.proxy(this._action, this));

    this.$win.on('load', $.proxy(this._onLoaded, this));
    this.$win.on('scroll', $.proxy(this._onScroll, this));
    this.$win.on('resize', $.proxy(this._onResize, this));

    if ($("body").hasClass("elementor-editor-active")) {
      this._hasIntro = false;
      this._onLoaded();
    }
    $('.nav').mouseleave(function() {
      $('.header').height(60)
    });


    $('.nav>li').hover(function(){
      let h = $(this).find('ul').height() + 40;
      if (h > 40) $('.header').height(h)
    })


    SmoothScroll()
    // Log scroll events
    var logScrollEvent = function (event) {

    	// The event type
    	console.log('type:', event.type);

    	// The anchor element being scrolled to
    	console.log('anchor:', event.detail.anchor);

    	// The anchor link that triggered the scroll
    	console.log('toggle:', event.detail.toggle);

    };

    // Listen for scroll events
    document.addEventListener('scrollStart', logScrollEvent, false);
    document.addEventListener('scrollStop', logScrollEvent, false);
    document.addEventListener('scrollCancel', logScrollEvent, false);

    //
    // const section = document.querySelector('body')
    // const smooth = new Smooth({
    //   native: true,
    //   section: section,
    //   ease: 0.1
    // })
    //
    // smooth.init()



  },
  finalize() {
      var wow = new WOW({
          offset:10
      });
      wow.init();


      let titles = [];
      $('.summary h3').each(function() {
        titles.push($(this).addClass('wc-block').detach());
      })
      let c = 4;

      for (var i = 0; i < titles.length; i++) {
        titles[i].insertAfter(`.woocommerce-product-gallery__image:nth-child(${c})`);
        c+=3;
      }

      if ($('h3.wc-block').length > titles.length) {
        $('h3.wc-block').last().remove();
      }
      $('h3.wc-block').addClass('woocommerce-product-gallery__image');





      // $('.summary h3').addClass('woocommerce-product-gallery__image').detach().insertAfter('.woocommerce-product-gallery__image:nth-child(4)');
      $('.summary').addClass('woocommerce-product-gallery__image').detach().insertAfter('.isotope .woocommerce-product-gallery__image:first-child');

      setTimeout(() => {
        if ($( ".isotope" ).length) {
          var iso = new Isotope( '.woocommerce-product-gallery .isotope', {
            itemSelector: '.woocommerce-product-gallery__image',
          });
        }
      }, 100);

  },

  _onLoaded() {

      if (this._skipload) return;
      this._onResize();
      // setTimeout(function() {

      $('.hero-image .elementor-image').each(function() {
        let imgSrc = $(this).find('img').attr('src');
        $(this).css({'background-image':`url(${imgSrc})`});
      })

      $("#wrapper").fadeTo(1000, 1).removeClass('not-visible');

      $('.animated').each(function(){
        $(this).removeClass('hidden');
        $(this).addClass($(this).data('anim'));
      });


      $("#loader").fadeTo(1000, 0, function() {
          $(this).addClass('hidden')
      });
      // var wow = new WOW({
      //     offset:10
      // });
      // wow.init();
      $('.cart-fixed').addClass('open');
      // var request = requestAnimationFrame(this._parallaxScroll)

      requestAnimationFrame(this._parallaxScroll.bind(this))


      // }, 0);
  },

  _onResize() {
      var wh = this.$win.height();
      if (this._states.md.matches) {
          var h = wh * 65/100;
          var h2 = wh * 35/100;
          var h3 = wh * 50/100;
          $('.intro-image').height(h);
          if (this._hasIntro) $('.header').css({top:h});
          this.navHeight = h + 100;
          $('.intro').height(h2);
          $('.hero-image,.hero-image .elementor-image').height(h3);
      } else {
          $('.intro-image').height(wh);
          $('header.header').removeAttr('style');
      }

  },

  _onScroll(evt) {

      if (!this._states.md.matches) return;

      if (this._hasIntro && this.$win.scrollTop() > this.navHeight) {
          this._hasIntro = false;
          $('header.header').removeAttr('style');
          setTimeout(function() {
              $('header.header').addClass('fixed');
          }, 50);
      }
      if (this.$win.scrollTop() < this.navHeight && $('header.header').hasClass('fixed') ) {
          this._hasIntro = true;
          this._onResize();
          $('header.header').removeClass('fixed');
      }
      if (this.$win.scrollTop() > 590) {
          $('.lft-menu').addClass('fixed');
      } else {
          $('.lft-menu').removeClass('fixed');
      }


       // this._parallaxScroll();
  },

  _parallaxScroll(evt) {

      var currTop = this.$win.scrollTop();



      $('.bg-parallax, .hero-image .elementor-image').each(function() {
          var scrolled = currTop - $(this).position().top;
          var easing = $(this).data('easing') || 4;
          var newY = scrolled/-easing+'px';
          $(this).css("backgroundPosition", "center " + newY);
      })

      if ($('.parallaxes').size()<=0) {
        requestAnimationFrame(this._parallaxScroll.bind(this));
        return;
      }

      var scrolled = currTop - $('.parallaxes').position().top + this.$win.height()/4;
      $(".parallax").each(function() {
          var easing = $(this).data('easing');
          $(this).css({
              'transform': 'translate3d(0,' +- (scrolled * easing) + 'px, 0)'
          });
      })
      requestAnimationFrame(this._parallaxScroll.bind(this));

  },

};



// WEBPACK FOOTER //
// ./scripts/routes/common.js